/**
 * FIXERLIGHT-049 — le statut d'un fil de messages (`open`/`closed`) est déjà
 * le mot rendu par l'api (`ClientMessageThreadResource`, contrat § 4 :
 * `closed_at === null ? "open" : "closed"`), pas un statut technique brut —
 * contrairement à `workshopBookingStatus.js`, ce mapping ne fait donc que
 * la traduction et la couleur de badge, jamais de dérivation.
 */

const STATUS_I18N_KEYS = {
  open: 'messages.status.open',
  closed: 'messages.status.closed',
};

const STATUS_BADGE_COLORS = {
  open: 'blue',
  closed: 'gray',
};

/** Clé i18n du statut, ou null si le statut n'est pas reconnu (fail-open). */
export function messageThreadStatusKey(status) {
  return STATUS_I18N_KEYS[status] || null;
}

/** Groupe de couleur Badge pour ce statut ; gris si non reconnu. */
export function messageThreadStatusColor(status) {
  return STATUS_BADGE_COLORS[status] || 'gray';
}

// Le `kind` de `MessageThreadActionError` (`services/messageThreads.js`) —
// une classification de secours, l'api ne rendant pas de `code` machine sur
// ce contrat (contrairement à `WorkshopBookingActionError`) — mappé sur une
// phrase claire.
const ACTION_ERROR_I18N_KEYS = {
  validation: 'messages.error.validation',
  booking_invalid: 'messages.error.bookingInvalid',
  booking_not_found: 'messages.error.bookingNotFound',
  rate_limited: 'messages.error.rateLimited',
  thread_closed: 'messages.error.threadClosed',
  not_found: 'messages.error.notFound',
  reopen_unavailable: 'messages.error.reopenUnavailable',
  generic: 'messages.error.generic',
};

/** Clé i18n pour un `MessageThreadActionError.kind` ; générique si absent
 * ou non reconnu. */
export function messageThreadActionErrorKey(kind) {
  return ACTION_ERROR_I18N_KEYS[kind] || ACTION_ERROR_I18N_KEYS.generic;
}
